import useConfigurationStore from "../store/configurationStore.ts";
import Dropdown from "react-dropdown";
import {useEffect, useState} from "react";
import _ from "lodash";
declare const configTrads: any;


const _trad = (key: string) : string =>  configTrads[key] ? configTrads[key] : key;


export const HerbergementChoice = ({showError,errors}:{showError: boolean, errors:{type: string,message: string}[][]}) => {
    const store = useConfigurationStore(state => state);
    const [categorieChambreOptions, setCategorieChambreOptions] = useState<{ value: string, label: string }[]>([]);
    const [moreDaysOptions, setMoreDaysOptions] = useState<{ value: string, label: string }[]>([]);
    const [chambreOptions, setChambreOptions] = useState<{ value: string, label: string }[]>([])
    const [chambreLastOptions, setChambreLastOptions] = useState<{ value: string, label: string }[]>([])
    const [nbPack, setNbPack] = useState<number>(1);
    const [indexToShowRoom, setIndexToShowRoom] = useState<number>(0);

    const [indexOfLastRoom, setIndexOfLastRoom] = useState<number>(1000);
    const [nbPackFirstLoaded, setNbPackFirstLoaded] = useState<boolean>(false);
    /*const [categorieChambreFirstLoaded, setCategorieChambreFirstLoaded] = useState<boolean>(false);*/

    useEffect(() => {
        if(store.packageDetail && store.packageDetail.package_avec_hebergement){
            setCategorieChambreOptions((store.packageDetail.categorie_de_chambre || []).map((cat) => {

                return ({
                    value: cat.intitule,
                    label: cat.intitule + (cat.prix === 0 ? _trad(' (inclus)') : ' (+' + cat.prix + '€)')
                })
            }));
            setNbPack(store.choices.nbPack || 1)
        }
    }, [store.packageDetail]);

    useEffect(() => {
        if(nbPack !== store.choices.nbPack){
            setNbPack(store.choices.nbPack || 1);
            if(nbPackFirstLoaded){
                store.setChoice("chambres", []);
                treatChambre()
            }
            setNbPackFirstLoaded(true);
        }
    }, [store.choices.nbPack]);


    useEffect(() => {
        if(!store.packageDetail) return
        const catChambre = _.find(store.packageDetail?.categorie_de_chambre || [], (cat) => cat.intitule === store.choices.categorieChambre);
        /*if(categorieChambreFirstLoaded){
            store.setChoice("chambres", []);
            store.setChoice("moreDays", null);
            setCategorieChambreFirstLoaded(true);
        }*/
        if(!catChambre){
            setChambreOptions([]);
            setChambreLastOptions([]);
            return;
        }
        setChambreOptions([
            {value: "Double", label: _trad("Chambre double ") + (catChambre.prix_chambre_double === 0 ? _trad("(inclus)") :"(+"+catChambre.prix_chambre_double+"€)")},
            {value: "Twin", label: _trad("Chambre twin ") + (catChambre.prix_chambre_twin === 0 ? _trad("(inclus)") :"(+"+catChambre.prix_chambre_twin+"€)")},
            {value: "Single", label: _trad("Chambre single ") + (catChambre.prix_chambre_single === 0 ? _trad("(inclus)") :"(+"+catChambre.prix_chambre_single+"€)")},
        ])
        /*setChambreLastOptions([
            {value: "Double", label: "Chambre double "+ (catChambre.prix_chambre_double === 0 ? "(inclus)" :"(+"+catChambre.prix_chambre_double+"€)")},
            {value: "Twin", label: "Chambre twin "+ (catChambre.prix_chambre_twin === 0 ? "(inclus)" :"(+"+catChambre.prix_chambre_twin+"€)")},
            {value: "Single", label: "Chambre single "+ (catChambre.prix_chambre_single === 0 ? "(inclus)" :"(+"+catChambre.prix_chambre_single+"€)")},
        ])*/
        treatChambre()
        const moreDaysNew = _.map(catChambre.prolongation_de_sejour, (p) => ({value: p.nombre_de_jour, label: p.nombre_de_jour+ (p.prix === 0 ? _trad(' (inclus)') : ' (+'+p.prix+'€)')}));
        setMoreDaysOptions(moreDaysNew.length > 0 ? [
            {value: '0', label: '0'},
            ...moreDaysNew,
            ] : []
        );
    }, [store.choices.categorieChambre,store.choices.chambres,store.choices.nbPack, store.packageDetail]);

    const treatChambre = () => {
        const countRoomFill = store.choices.chambres.reduce((v,c) => v + (c === 'Single' ? 1 : 2), 0);

        if(countRoomFill === store.choices.nbPack){
            //nothing
            setIndexToShowRoom(store.choices.chambres.length - 1)
            setIndexOfLastRoom(store.choices.chambres.length - 1)
            const catChambre = _.find(store.packageDetail?.categorie_de_chambre || [], (cat) => cat.intitule === store.choices.categorieChambre);
            if (catChambre) {
                if (store.choices.chambres[store.choices.chambres.length - 1] === 'Single') {
                    setChambreLastOptions([
                        {
                            value: "Single",
                            label: _trad("Chambre single ") + (catChambre.prix_chambre_single === 0 ? _trad("(inclus)") : "(+" + catChambre.prix_chambre_single + "€)")
                        },
                    ])
                }else{
                    setChambreLastOptions([
                        {value: "Double", label: _trad("Chambre double ") + (catChambre.prix_chambre_double === 0 ? _trad("(inclus)" ):"(+"+catChambre.prix_chambre_double+"€)")},
                        {value: "Twin", label: _trad("Chambre twin ") + (catChambre.prix_chambre_twin === 0 ? _trad("(inclus)") :"(+"+catChambre.prix_chambre_twin+"€)")},
                        {value: "Single", label: _trad("Chambre single ") + (catChambre.prix_chambre_single === 0 ? _trad("(inclus)") :"(+"+catChambre.prix_chambre_single+"€)")},
                    ])
                }
            }
        }else {
            setIndexToShowRoom(store.choices.chambres.length)
            const catChambre = _.find(store.packageDetail?.categorie_de_chambre || [], (cat) => cat.intitule === store.choices.categorieChambre);
            if (catChambre){
                if (((store.choices.nbPack || 1) - countRoomFill) === 1) {
                    setChambreLastOptions([
                        {
                            value: "Single",
                            label: _trad("Chambre single ") + (catChambre.prix_chambre_single === 0 ? _trad("(inclus)") : "(+" + catChambre.prix_chambre_single + "€)")
                        },
                    ])
                    setIndexOfLastRoom(store.choices.chambres.length)
                    if(store.choices.nbPack === 1) store.setChoice("chambres", ["Single"])
                } else {
                    setChambreLastOptions([
                        {
                            value: "Double",
                            label: _trad("Chambre double ") + (catChambre.prix_chambre_double === 0 ? _trad("(inclus)") : "(+" + catChambre.prix_chambre_double + "€)")
                        },
                        {
                            value: "Twin",
                            label: _trad("Chambre twin ") + (catChambre.prix_chambre_twin === 0 ? _trad("(inclus)") : "(+" + catChambre.prix_chambre_twin + "€)")
                        },
                        {
                            value: "Single",
                            label: _trad("Chambre single ") + (catChambre.prix_chambre_single === 0 ? _trad("(inclus)") : "(+" + catChambre.prix_chambre_single + "€)")
                        },
                    ])
                    setIndexOfLastRoom(1000)
                }
            }
        }
    }
    const editChambre = (i: number, value: string) => {
        const newChambres = [...store.choices.chambres.slice(0, i), value];
        const countRoomFill = newChambres.reduce((v,c) => v + (c === 'Single' ? 1 : 2), 0);
        if(((store.choices.nbPack || 1) - countRoomFill) === 1) newChambres.push('Single');
        store.setChoice("chambres", newChambres);
    }


    return (<>
        {store.choices.nbPack &&<div className="vertical-gap">
            <div className="">
                {/*<div>Quelle catégorie de chambre souhaitez-vous choisir&nbsp;?</div>*/}
                <Dropdown options={categorieChambreOptions} onChange={(e) => store.setChoice("categorieChambre",e.value)}  value={store.choices.categorieChambre || ''} placeholder={_trad("Sélectionnez votre catégorie d’hôtel")} />
            </div>
            {store.choices.categorieChambre && <div>
                <hr style={{marginBottom:'10px'}}/>
                {_.range(0, store.choices.nbPack).map((i) => {
                    return (<div key={i}>
                        {i <= indexToShowRoom && <>
                            <div className="flex-row-between fix-dropdown"  style={{marginBottom:'10px'}}>
                                <strong>{_trad("Chambre")} {i+1}</strong>
                                {i !== indexOfLastRoom &&
                                    <Dropdown options={chambreOptions} onChange={(e) => editChambre(i,e.value)} value={chambreOptions.find(c => c.value === store.choices.chambres[i])} placeholder={_trad("Sélectionnez votre chambre")} />
                                }
                                {(i === indexOfLastRoom || i === ((store.choices.nbPack || 1) -1)) &&
                                    <Dropdown options={chambreLastOptions} onChange={(e) => editChambre(i,e.value)} value={chambreLastOptions.find(c => c.value === store.choices.chambres[i])} placeholder={_trad("Sélectionnez votre chambre")} />
                                }
                            </div>
                            {/*{store.choices.chambres[0] && i === 0 && (store.choices.nbPack || 0) > 2
                                && (!_.every(store.choices.chambres,(chambre) => chambre === store.choices.chambres[0])
                                || store.choices.chambres.length < Math.ceil((store.choices.nbPack || 1)/2))
                                && <div style={{marginBottom:'10px', marginTop:'-5px', textAlign:'right'}}>
                                <a className="clickable small" onClick={allSameRoom}>Je veux le même type de chambre pour tout le monde</a>
                            </div>}*/}
                        </>}
                    </div>)
                })}
                {moreDaysOptions.length > 0 && <>
                    <hr style={{marginBottom:'10px'}}/>
                    <div className="flex-row-between">
                        <div>{_trad("Nombre de jour de prolongation")}&nbsp;?</div>
                        <Dropdown options={moreDaysOptions} onChange={(e) => store.setChoice("moreDays",e.value)} value={store.choices.moreDays || ''}  placeholder={_trad("Nombre de jour")} />
                    </div>
                </>}
            </div>}

        </div>}
        {showError && !!errors.find(e => e[0].type === "HÉBERGEMENT")  && <div className="error">
            {(errors.find(e => e[0].type === "HÉBERGEMENT") || []).map((e) => <h5 style={{'marginTop':'10px'}}>{_trad(e.message)}</h5>)}
        </div>}
    </>
    )
}
